/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RequiredProductionDataFileTypes { 
    dataFileTypes: Array<RequiredProductionDataFileTypes.DataFileTypesEnum>;
}
export namespace RequiredProductionDataFileTypes {
    export const DataFileTypesEnum = {
        Gps: 'GPS',
        Mor: 'MOR',
        Adf: 'ADF',
        Adf3: 'ADF3',
        Csq: 'CSQ',
        ConfigCollar: 'CONFIG_COLLAR',
        InfoCollar: 'INFO_COLLAR',
        Report: 'REPORT',
        Prx: 'PRX',
        Sep: 'SEP',
        Vit: 'VIT',
        Mit: 'MIT',
        ConfigDropOff: 'CONFIG_DROP_OFF',
        InfoDropOff: 'INFO_DROP_OFF',
        DropOffKey: 'DROP_OFF_KEY',
        ConfigExternalDropOff: 'CONFIG_EXTERNAL_DROP_OFF',
        InfoExternalDropOff: 'INFO_EXTERNAL_DROP_OFF',
        Debug: 'DEBUG',
        ConfigTrap: 'CONFIG_TRAP',
        LogTrap: 'LOG_TRAP',
        InfoTrap: 'INFO_TRAP',
        AccBin: 'ACC_BIN',
        MagBin: 'MAG_BIN'
    } as const;
    export type DataFileTypesEnum = typeof DataFileTypesEnum[keyof typeof DataFileTypesEnum];
}


export type DataFileTypesEnum = typeof RequiredProductionDataFileTypes.DataFileTypesEnum[keyof typeof RequiredProductionDataFileTypes.DataFileTypesEnum];
